import { useState, Fragment } from "react";
import { formatInline } from "@/lib/inline";

const Poll = ({ question, options }) => {
  const [sel, setSel] = useState(null);
  return (
    <div className="pt-4" data-testid="blue-poll">
      <p className="mb-5 text-xl font-bold">{question}</p>
      <div className="flex max-w-md flex-col gap-3">
        {options.map((o, i) => (
          <button
            key={o}
            onClick={() => setSel(i)}
            className={`rounded-xl px-5 py-3 text-left text-base font-medium ring-1 transition ${
              sel === i
                ? "bg-white text-[#2f68b0] ring-white"
                : "bg-white/10 text-white ring-white/30 hover:bg-white/20"
            }`}
          >
            {o}
          </button>
        ))}
      </div>
    </div>
  );
};

const Block = ({ block }) => {
  switch (block.type) {
    case "h":
      return <h3 className="mt-8 text-xl font-bold md:text-2xl">{formatInline(block.text)}</h3>;
    case "list":
      return (
        <ul className="list-disc space-y-2 pl-6 text-lg leading-8">
          {block.items.map((it) => (
            <li key={it}>{formatInline(it)}</li>
          ))}
        </ul>
      );
    case "cta":
      return (
        <div className="pt-2">
          <a
            href={block.href}
            target="_blank"
            rel="noopener noreferrer"
            className="isic-btn-onblue"
            data-testid="blue-cta"
          >
            {block.label}
          </a>
        </div>
      );
    case "poll":
      return <Poll question={block.question} options={block.options} />;
    default:
      return (
        <p className="text-lg leading-8 md:text-xl md:leading-9">
          {block.text.split("\n").map((line, i) => (
            <Fragment key={i}>
              {i > 0 && <br />}
              {formatInline(line)}
            </Fragment>
          ))}
        </p>
      );
  }
};

export const BlueSection = ({ bigBlock }) => {
  if (!bigBlock) return null;
  return (
    <section className="isic-blue-bg py-16 md:py-24" data-testid="blue-info-section">
      <div className="mx-auto max-w-[1100px] px-6 text-white">
        <h1 className="text-4xl font-extrabold sm:text-5xl">{bigBlock.heading}</h1>
        {bigBlock.intro && <p className="mt-4 text-xl opacity-90">{bigBlock.intro}</p>}
        <div className="mt-8 space-y-5">
          {bigBlock.blocks.map((b, i) => (
            <Block key={`${b.type}-${i}`} block={b} />
          ))}
        </div>
      </div>
    </section>
  );
};
